import React, { isValidElement } from 'react';

const LabelIcon = ({ label, icon, className, isSvg }) => {
  const _className = className || 'flex text-xl text-left items-center gap-4';
  const isElemen = isValidElement(icon);

  return (
    <span className={_className}>
      {isElemen ? icon : <img alt="-" src={icon} />} {label}
    </span>
  );
};

export default LabelIcon;
